module.exports = __webpack_public_path__ + "static/media/betyaros-aszf.4f717a8a.pdf";